export const lineFragmentShader = `
uniform vec3 color;
uniform float opacity;
uniform float mode;

varying vec3 vColor;
varying float vOpacity;
varying float distToCamera;

void main() {
	//float distMult = (1.0 + (0.01618*distToCamera));
	float distMult = (1.0 + (0.01618*distToCamera));
	if(mode == 1.0){
		distMult = 1.0;
	}
	if(mode == 0.0){
		distMult = 0.0;
	}
	if(vOpacity <= 0.1){
		distMult = 0.0;
	}

	//fog out twin peaks in the background vs the foreground
	gl_FragColor = vec4( vColor * color, ((opacity * vOpacity) + 0.30) *distMult);
}
`